<template>
    <div class="catering-order has-background-background">
        <transition name="fade" mode="out-in">
            <ListLoader v-if="initLoading" />
            <ListPlaceholder
                title="ORDER_NOT_AVAILABLE"
                v-else-if="!order.school_id"
            />
            <div v-else-if="!initLoading && order.school_id">
                <div class="container is-max-desktop">
                    <div class="box is-shadowless">
                        <img
                            class="is-hidden-desktop mb-4"
                            style="width: 130px"
                            :src="$env.getAppLogo().logo"
                            alt="logo"
                        />
                        <div class="level is-mobile">
                            <div class="level-left">
                                <div class="level-item">
                                    <h1
                                        class="title"
                                        v-text="$t('CATERING_ORDER')"
                                    />
                                </div>
                            </div>
                            <div class="level-right is-hidden-touch">
                                <img
                                    style="width: 200px"
                                    :src="$env.getAppLogo().logo"
                                    alt="logo"
                                />
                            </div>
                        </div>
                        <div class="columns">
                            <div class="column">
                                <div class="field">
                                    <label
                                        class="label"
                                        v-text="$t('ORDER_DATE')"
                                    />
                                    <p
                                        class="has-text-weight-semibold has-text-primary"
                                        v-text="orderDate"
                                    />
                                </div>
                            </div>
                            <div class="column is-8">
                                <div class="field">
                                    <label
                                        class="label"
                                        v-text="$t('ORDER_SCHOOL_NAME')"
                                    />
                                    <p
                                        class="has-text-weight-semibold"
                                        v-text="order.school_name"
                                    />
                                </div>
                            </div>
                        </div>
                        <table class="table is-fullwidth">
                            <thead>
                                <tr>
                                    <th v-text="$t('BILL_SUM')" />
                                    <th v-text="$t('LABEL_SINGLE_MEAL')" />
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(meal, index) in order.meals_by_kind"
                                    :key="index"
                                >
                                    <td style="width: 6rem">
                                        {{ meal.quantity }}
                                    </td>
                                    <td>{{ meal.name }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <CateringContactForm />
            </div>
        </transition>
    </div>
</template>
<script>
import api from '@/helpers/api'
import CateringContactForm from './CateringContactForm.vue'
export default {
    components: { CateringContactForm },
    data() {
        return {
            initLoading: true,
            order: {
                date: '2020-10-15',
                school_name:
                    'Przedszkole Niepubliczne Zgromadzenia Sióstr Zmartwychwstania Pańskiego im. świętego Józefa',
                meals_by_kind: [
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    },
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    },
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    },
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    },
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    },
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    },
                    {
                        name: 'Nazwa posiłku',
                        quantity: 44
                    }
                ]
            }
        }
    },
    computed: {
        orderDate() {
            return this.$moment(this.order.date).format('DD.M.YYYY')
        }
    },
    methods: {
        async getOrder() {
            try {
                const { order } = this.$route.params
                const { region } = this.$route.query
                if (!region || !order) {
                    this.initLoading = false
                    return
                }
                const lang = this.$Language.getLangFromRegion(region)
                this.$Language.selectLanguage(lang)
                this.$store.commit('setRegion', region)
                const data = await api.get(`v1/catering/order/${order}`)
                this.order = data
                this.initLoading = false
            } finally {
                this.initLoading = false
            }
        }
    },
    mounted() {
        this.getOrder()
    }
}
</script>
<style lang="scss" scoped>
.catering-order {
    width: 100vw;
    height: 100vh;
    max-height: 100vh;
    overflow-y: auto;
    padding: 1rem;

    @media (max-width: $tablet) {
        padding: 0;
    }
}
</style>
